import { StarFilled, StarOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import React, { useContext, useState } from "react";
import "../../../assets/css/outbound.css";
import { AppContext } from "../../../context/AppContext";
import useHttp from "../../../hooks/useHttp";

const SetAsDefaultPhone = React.memo((props) => {
    const { item } = props;
    const [appProperties, setAppProperties] = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const { fetchData } = useHttp();
    const defaultPhoneNumber = appProperties?.defaultPhoneNumber;
    const isDefaultPhoneNumber = defaultPhoneNumber && item?.phoneNumber === defaultPhoneNumber;
    const handleSetDefaultNumber = (e, method) => {
      e.stopPropagation();
      setLoading(true);
      try {
        if (method === "add") {
          fetchData(
            `${item?.integId}/number/default?phoneNumber=${encodeURIComponent(item?.phoneNumber)}`,
            "PUT",
            null,
            appProperties
          ).then(function (response) {
            if (response) {
              response = JSON.parse(response);
              response = response?.data;
              if (response?.success) {
                setAppProperties((prev) => ({
                  ...prev,
                  defaultPhoneNumber: item?.phoneNumber,
                }));
                message.success(response?.data || "Default number Saved successfully");
              } else {
                message.error(response?.errorMessage || "Failed to save default number");
              }
            }
          });
        } else {
          fetchData(
            `${item?.integId}/number/default?phoneNumber=${encodeURIComponent(item?.phoneNumber)}&action=remove`,
            "PUT",
            null,
            appProperties
          ).then(function (response) {
            if (response) {
              response = JSON.parse(response);
              response = response?.data;
              if (response?.success) {
                message.success(response?.data || "Default number removed successfully");
                setAppProperties((prev) => ({
                  ...prev,
                  defaultPhoneNumber: "",
                }));
              } else {
                message.error(response?.errorMessage || "Failed to remove default number");
              }
            }
          });
        }
      } catch (error) {
        console.error("Error", error);
      } finally {
        setLoading(false);
      }
    };
    return (
      <>
        <Button
          loading={loading}
          bordered={null}
          type="link"
          onClick={(e) => {
            handleSetDefaultNumber(e, isDefaultPhoneNumber ? "remove" : "add");
          }}
          className={
            item?.phoneNumber === defaultPhoneNumber ? "defaultPhoneStarred labelMode" : "defaultPhone labelMode"
          }
        >
          {item?.phoneNumber === defaultPhoneNumber ? (
            <StarFilled className="hs-color-violet hs-fs-15" />
          ) : (
            <StarOutlined className="hs-color-violet hs-fs-15" />
          )}
        </Button>
      </>
    );
  });

export default SetAsDefaultPhone;